import { DropdownAlignment } from 'eone-ui/dropdown-panel/dropdown-panel';
import { SCInputSelect } from './sc_input_select';

function SCInputDropdownButton(props) {
  if (!props.Show) {
    return null;
  }

  return (
    <SCInputSelect
      Icon={props.Icon}
      Placeholder={props.Placeholder}
      LabelRender={props.LabelRender}
      MultiSelect={props.Array}
      Options={props.Options}
      ReadOnly={props.ReadOnly}
      Value={props.Value}
      ContainerClass="eone-ui-select-container-input-dropdown"
      DropdownClass="eone-ui-input-dropdown"
      DropdownLabel={props.DropdownLabel}
      Search={props.ShowSearch}
      Loading={props.Loading}
      OnChange={props.OnChange}
      DropdownAlignment={DropdownAlignment.AlignRight}
    />
  );
}

export { SCInputDropdownButton };
